/* eslint-disable max-len */

export default {
  blocks: [
    {
      key: '4i3kf',
      text: 'Paragraph with invalid style',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        {
          offset: 95,
          length: 75,
          style: '14',
        },
      ],
      entityRanges: [],
      data: {},
    },
  ],
  entityMap: {},
  documentStyle: {},
  VERSION: '8.70.22',
  ID: 'c2e1f570-2729-4cb6-b973-99a1115dd7cb',
};
